import {
  Button,
  ButtonProps,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  MenuListProps,
  MenuProps,
  Text,
} from '@chakra-ui/react';
import {ChevronDownIcon} from '@chakra-ui/icons';
import {ReactNode} from 'react';

// Style commun pour les boutons de filtre
const filterButtonStyle = {
  bg: 'gray.50',
  color: 'gray.dark',
  fontWeight: 'normal',
  // h: '32px',
  p: '4',
  fontSize: 'sm',
  _hover: {
    bg: 'gray.100',
  },
} as const;

interface FilterButtonProps extends Omit<
  ButtonProps,
  'rightIcon' | 'leftIcon'
> {
  label: string;
  menuProps?: Omit<MenuProps, 'children'>;
  menuListProps?: MenuListProps;
  chevronColor?: string;
  leftIcon?: ReactNode;
  children?: ReactNode;
}

// Composant réutilisable pour les boutons de filtre
export const FilterButton = ({
  label,
  menuProps,
  menuListProps,
  children,
  chevronColor = 'gray.600',
  leftIcon,
  ...buttonProps
}: FilterButtonProps) => {
  return (
    <Menu {...menuProps}>
      <MenuButton
        as={Button}
        {...filterButtonStyle}
        {...buttonProps}
        rightIcon={
          <ChevronDownIcon
            color={chevronColor}
            w={3}
            h={3}
          />
        }
      >
        {leftIcon ? (
          <HStack
            spacing={1}
            alignItems='center'
          >
            <>{leftIcon}</>
            <Text>{label}</Text>
          </HStack>
        ) : (
          label
        )}
      </MenuButton>
      <MenuList {...menuListProps}>{children}</MenuList>
    </Menu>
  );
};
